var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.className,attrs:{"type":"button"},on:{"click":_vm.toggleContact}},[_vm._v(" "+_vm._s(this.$t("general.contactbutton"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }